import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import {
  SubflowTemplateFormSchema,
  SubflowTemplateSchema,
} from './subflow-templates.schema';

const { FLOW } = PERMISSIONS;

export const subflowTemplatesContract = createRESTContract({
  getAllSubflowTemplates: {
    method: 'GET',
    path: '/subflow-templates',
    permissions: [FLOW.SUBFLOW_TEMPLATES_LIST],
    response: z.array(SubflowTemplateSchema),
  },
  deleteSubflowTemplate: {
    method: 'DELETE',
    path: '/subflow-templates/:key',
    permissions: [FLOW.SUBFLOW_TEMPLATES_DELETE],
    body: z.undefined(),
    response: z.void(),
  },
  createSubflowTemplate: {
    method: 'POST',
    path: '/subflow-templates',
    permissions: [FLOW.SUBFLOW_TEMPLATES_CREATE],
    body: SubflowTemplateFormSchema,
    response: z.array(SubflowTemplateSchema),
  },
});
